<template>
  <div class="tab-view">
    <LeeaCard class="checkins-card">
      <template #title>Daily Checkins</template>
      <template #content>
        <div class="days-row">
          <template v-for="index in 7" :key="index">
            <Number :active="index <= userStore.streakDays!">{{ index }}</Number>
            <div
              v-if="index < 7"
              class="line"
              :class="{ active: index + 1 <= userStore.streakDays! }"
            ></div>
          </template>
        </div>
        <div class="checkin-reward-text">Next day reward:</div>
        <Rewards :value="tasksStore.dailyRewards![Math.min(userStore.streakDays! + 1, 7)]" />
      </template>
    </LeeaCard>
    <div class="tasks-list">
      <div v-for="task of tasksStore.tasks" :key="task.id">
        <TaskRow :task="task" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import TaskRow from '@/components/Task.vue'
import { useTasksStore } from '@/stores/tasks'
import LeeaCard from './LeeaCard.vue'
import { useUserStore } from '@/stores/user'
import Number from '@/components/Number.vue'
import Rewards from '@/components/Rewards.vue'
import { analyticsService } from '@/services/analytics.service'
analyticsService.logTab('Earn')

const tasksStore = useTasksStore()
const userStore = useUserStore()
</script>

<style lang="scss" scoped>
.tab-view {
  justify-content: flex-start;

  .checkins-card {
    width: auto;
  }

  .checkin-reward-text {
    margin: 30px 0 10px;
    font-size: 26px;
    font-family: 'Forma DJR Display', sans-serif;
    letter-spacing: 1.2px;
  }

  .days-row {
    display: flex;
    justify-content: stretch;
    align-items: center;
    width: 100%;

    .number {
      box-shadow: 0 0 20px var(--blue-color);
    }

    .line {
      box-shadow: 0 0 20px var(--blue-color);
      justify-self: stretch;
      height: 1px;
      background-color: white;
      flex-grow: 1;

      &.active {
        height: 3px;
        background-color: var(--blue-color);
      }
    }
  }
}
</style>
